import { useState } from "react";
import { toast } from "sonner";
import { ChevronDown, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/apiClient";

const MAX = 2000;

export const AboutEditor = ({ slug, initial }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(initial || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put(`/admin/about/${slug}`, { text });
      setText(r.data.about);
      toast.success("About text saved — it's live on the channel page.");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed to save");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-4 border-t border-white/10 pt-3">
      <button
        data-testid={`admin-about-toggle-${slug}`}
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] text-zinc-400 hover:text-white transition-colors"
      >
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} /> About this channel text
      </button>
      {open && (
        <div className="mt-3 space-y-2">
          <textarea
            data-testid={`admin-about-input-${slug}`}
            value={text}
            maxLength={MAX}
            onChange={(e) => setText(e.target.value)}
            rows={6}
            className="w-full bg-[#030305] border border-white/10 rounded-sm px-3 py-2 text-sm text-white leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#FF2A2A]"
          />
          <div className="flex items-center justify-between">
            <span className="text-xs text-zinc-500">{text.length}/{MAX} · leave empty to restore the default</span>
            <button
              data-testid={`admin-about-save-${slug}`}
              onClick={save}
              disabled={busy}
              className="flex items-center gap-1.5 bg-[#FF2A2A] hover:bg-[#FF4D4D] disabled:opacity-60 text-white px-4 py-2 rounded-sm text-sm font-medium transition-colors"
            >
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
